var map = {
	"./AlumCliffs.png": 4408,
	"./ApsleyWaterholeGorge.png": 8869,
	"./CradleMountSummit.png": 1883,
	"./CraterLakeCircuit.png": 4163,
	"./DoveLake.png": 8697,
	"./OrganPipes.png": 5954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5394;